const categories = [
  { title: '动作冒险', count: '2,860部', icon: 'ri-sword-line', color: 'accent' },
  { title: '科幻巨制', count: '1,940部', icon: 'ri-rocket-line', color: 'primary' },
  { title: '喜剧搞笑', count: '3,120部', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { title: '恐怖惊悚', count: '1,580部', icon: 'ri-ghost-line', color: 'secondary' },
  { title: '爱情文艺', count: '2,340部', icon: 'ri-heart-line', color: 'accent' },
  { title: '动画动漫', count: '2,050部', icon: 'ri-palette-line', color: 'primary' },
  { title: '纪录写实', count: '1,260部', icon: 'ri-camera-line', color: 'secondary' },
  { title: '悬疑推理', count: '1,830部', icon: 'ri-search-eye-line', color: 'accent' },
  { title: '战争史诗', count: '1,090部', icon: 'ri-flag-line', color: 'primary' },
];

function colorClasses(color: string) {
  if (color === 'accent') return { bg: 'bg-accent-50', icon: 'text-accent-500', count: 'text-accent-600' };
  if (color === 'primary') return { bg: 'bg-primary-50', icon: 'text-primary-600', count: 'text-primary-700' };
  return { bg: 'bg-secondary-50', icon: 'text-secondary-600', count: 'text-secondary-700' };
}

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 border border-primary-200 mb-4">
            <i className="ri-grid-line text-primary-600 text-sm"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">分类导览</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            电影大全
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            按类型快速找到你想看的电影，海量资源一网打尽
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((cat, i) => {
            const c = colorClasses(cat.color);
            return (
              <a
                key={i}
                href="#ranking"
                className={`group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-xl cursor-pointer transition-all duration-200 ${c.bg} hover:scale-[1.02] border border-transparent hover:border-background-300/60`}
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-background-50/80">
                  <i className={`${cat.icon} ${c.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-50 whitespace-nowrap">
                    {cat.title}
                  </h3>
                  <p className={`text-xs mt-0.5 ${c.count} whitespace-nowrap`}>
                    {cat.count}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}